/*
 * File: /src/store/modules/groups.js
 * Created Date: Thursday May 30th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 30th May 2019 11:25:24 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { authedAxios } from 'src/shared/axiosWrapper';
import groupService from 'src/services/groupServices';
import contactServices from 'src/services/contactServices';

const state = {
  groups: undefined,
  individualGroups: []
};
const getters = {
  getGroups: state => {
    if (!state.groups) {
      return [];
    }
    return state.groups.filter(g => g.group_type == 'standard');
  },
  getGroupNameById: state => id => {
    const foundGroup = state.groups.find(group => +group.id === +id);
    if (foundGroup) {
      return foundGroup.name;
    }
    throw new Error(`Group with id ${id} not found`);
  },
  getSegments: state => {
    if (!state.groups) {
      return [];
    }
    return state.groups.filter(s => s.group_type == 'segment');
  }
};
const actions = {
  fetchGroups({ commit }) {
    return new Promise((resolve, reject) => {
      groupService
        .fetchGroups(false)
        .then(r => {
          commit('setGroups', r.data);
          resolve(r.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  checkGroupName({}, name) {
    return new Promise((resolve, reject) => {
      authedAxios
        .get('contacts/groups/exists/' + name)
        .then(r => {
          if (r.data.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  saveNewGroup({}, name) {
    return new Promise((resolve, reject) => {
      groupService
        .saveNewGroup({ name: name, group_type: 'standard' })
        .then(r => {
          resolve(r.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  updateGroupName({ commit }, meta) {
    return new Promise((resolve, reject) => {
      groupService
        .updateGroupNameById(meta.id, meta.name)
        .then(r => {
          commit('setGroupName', meta.id, meta.name);
          resolve(r.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  saveGroup({ commit }, group) {
    return groupService.saveGroup(group).then(r => {
      group.id = r.data.id; // Assign in case its a new group
      commit('setGroup', group);
    });
  },
  addContactToGroup({}, meta) {
    return new Promise(async (resolve, reject) => {
      // TODO: pull this from cache
      const r = await contactServices.fetchContactById(meta.contact);
      const existingContact = r.data;
      const groups = Object.assign([], existingContact.groups);
      groups.push({ id: meta.group });

      contactServices
        .patchContact(meta.contact, {
          groups: groups
        })
        .then(r => {
          resolve(r.data);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  removeContactFromGroup({}, meta) {
    return new Promise(async (resolve, reject) => {
      // TODO: pull from cache
      const existingContact = (
        await contactServices.fetchContactById(meta.contact)
      ).data;
      const groups = existingContact.groups.filter(group => {
        if (+group.id !== +meta.group) return group;
      });

      contactServices
        .patchContact(meta.contact, {
          groups: groups
        })
        .then(r => {
          resolve(r.data);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  unloadGroups({ commit }) {
    commit('setGroups', undefined);
  }
};

const mutations = {
  setGroupName(state, id, name) {
    const group = state.groups.find(g => g.id == id);
    if (group) {
      group.name = name;
    }
  },
  setGroups(state, groups) {
    state.groups = groups;
    // state.groups = Object.assign([], groups);
  },
  setIndividualGroups(state, groups) {},
  setGroup(state, group) {
    const index = state.groups.findIndex(g => {
      g.id = group.id;
    });
    if (index) {
      state.groups[index] = group;
    } else state.groups.push(group);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
